import type {HTMLAttributes, ReactNode} from 'react';

import {cn} from '../../../helpers/cn';
import {layoutDimensions} from '../../constants';

export type NavBarProps = HTMLAttributes<HTMLElement> & {
  /** Page title — truncates when space is tight. */
  title?: ReactNode;
  /** Back button or other content before the title (RTL: visually on the right). */
  leading?: ReactNode;
  /** Optional center slot between title and trailing action. */
  extra?: ReactNode;
  /** Header action on the opposite side of the title (RTL: visually on the left). */
  trailing?: ReactNode;
};

/**
 * Top app bar for mobile shell — pairs with `AppLayout.header`.
 * Shell wiring (router back, dynamic actions) lives in `shell/layout/Layout`.
 */
export function NavBar({title, leading, extra, trailing, className, ...props}: NavBarProps) {
  return (
    <header
      className={cn(
        'flex shrink-0 items-center justify-between gap-2 border-b border-gray-03 bg-white px-4',
        className
      )}
      style={{minHeight: layoutDimensions.navBarHeight}}
      {...props}
    >
      <div className="flex min-w-0 flex-1 items-center gap-1">
        {leading}
        {title != null && title !== '' ? (
          <span className="truncate text-subtitle-md text-gray-09">{title}</span>
        ) : null}
      </div>
      {extra ? <div className="flex shrink-0 items-center">{extra}</div> : null}
      {trailing ? <div className="flex shrink-0 items-center">{trailing}</div> : null}
    </header>
  );
}
